<template>
    <div class="table_wrap">
      <el-table :data="boardData"
                class="list-table"
                header-cell-class-name="list-header"
                empty-text="데이터가 없습니다."
                height="700"
      >
        <el-table-column label="카테고리순서" min-width="50" class-name="text-center" prop="">
          <template slot-scope="scope">
            <el-input v-model="scope.row.bc_seq" type="number" class="veryShort mr10"></el-input>
          </template>
        </el-table-column>
        <el-table-column label="카테고리명" min-width="150" class-name="text-center" prop="">
          <template slot-scope="scope">
           <el-input v-model="scope.row.bc_name" class="short mr10" maxlength="15" ></el-input>
          </template>
        </el-table-column>
        <el-table-column label="옵션" width="300" class-name="text-center" prop="">
          <template slot-scope="scope">
            <div class="row-info">
              <el-button class="reg_btn_out" @click="save(scope.row.bc_idx,scope.row.bc_seq,scope.row.bc_name)">
                저장
              </el-button>
              <el-button class="com_del" @click="deleteConfirm(scope.row,scope.$index)">
                삭제
              </el-button>
            </div>
          </template>
        </el-table-column>
      </el-table>
    </div>


<!--  <div class="table_wrap pb10">-->
<!--    <div class="btn_wrap pa10 text_right">-->
<!--    </div>-->
<!--    <div class="el-table list-table el-table&#45;&#45;fit el-table&#45;&#45;enable-row-hover el-table&#45;&#45;enable-row-transition el-table__body-wrapper is-scrolling-none">-->
<!--      <div class="">-->
<!--        <table cellspacing="0" cellpadding="0" border="0" style="width: 100%;" class="el-table__header">-->
<!--          <colgroup>-->
<!--            <col width="200">-->
<!--            <col width="500">-->
<!--            <col width="200">-->
<!--          </colgroup>-->
<!--          <thead class="has-gutter">-->
<!--          <tr>-->
<!--            <th class="is-leaf list-header">-->
<!--              <div class="cell">카테고리 순서</div>-->
<!--            </th>-->
<!--            <th class="is-leaf list-header">-->
<!--              <div class="cell">카테고리명</div>-->
<!--            </th>-->
<!--            <th class="is-leaf list-header">-->
<!--              <div class="cell">옵션</div>-->
<!--            </th>-->
<!--          </tr>-->
<!--          </thead>-->
<!--          <tbody>-->
<!--          <tr v-if="boardData.length === 0">-->
<!--            <td colspan="3">-->
<!--              <div class="cell text-center">-->
<!--                데이터가 없습니다.-->
<!--              </div>-->
<!--            </td>-->
<!--          </tr>-->
<!--          <tr v-for="(board, index) in boardData" :key="`boardCate${index}`" class="el-table__row">-->
<!--            <td>-->
<!--              <div class="cell text-center">-->
<!--                <div style="width: 150px; display: inline-block;">-->
<!--                  <el-input v-model="board.bc_seq" @blur="replaceNumber(board.bc_seq, index)"></el-input>-->
<!--                </div>-->
<!--              </div>-->
<!--            </td>-->
<!--            <td>-->
<!--              <div class="cell text-center">-->
<!--                <div style="width: 150px; display: inline-block;">-->
<!--                  <el-input v-model="board.bc_name"></el-input>-->
<!--                </div>-->
<!--              </div>-->
<!--            </td>-->
<!--            <td>-->
<!--              <div class="cell text-center">-->
<!--                <div class="row-info">-->
<!--                  <el-button @click="save(board.bc_idx, board.bc_seq, board.bc_name)">-->
<!--                    저장-->
<!--                  </el-button>-->
<!--                  <el-button @click="deleteConfirm(board.bc_idx)">-->
<!--                    삭제-->
<!--                  </el-button>-->
<!--                </div>-->
<!--              </div>-->
<!--            </td>-->
<!--          </tr>-->
<!--          </tbody>-->
<!--        </table>-->
<!--      </div>-->
<!--    </div>-->
<!--  </div>-->
</template>

<script>
import util from "@/mixins/util";
import EventBus from "@/utils/event-bus";
import boardValidator from "@/mixins/validators/boardValidator";

export default {
    name: "BoardWriteCategoryLayout",
    mixins: [boardValidator],
    components: {},
    inject: {
        boardWriteSetData: {
            default: () => {
            }
        },
        writeCategory: {
            default: () => {
            }
        },
        deleteCategory: {
            default: () => {
            }
        },
    },
    provide() {
        return {}
    },
    props: {
        boardData: {
            default: () => {
                return []
            }
        },

    },
    data() {
        return {

        }
    },
    created() {
    },
    mounted() {
      EventBus.$on('addCategory', this.addCategory);
    },
    beforeDestroy() {
      EventBus.$off('addCategory');
    },
    destroyed() {
    },
    computed: {},
    methods: {
        replaceNumber(value, index) {
          let pattern = /[^(0-9)]/gi;   // 숫자이외는 제거

          if(pattern.test(value)) {
            this.boardData[index].bc_seq = value.replace(pattern, "");
            if(this.boardData[index].bc_seq != '') {
              this.boardData[index].bc_seq = Number(this.boardData[index].bc_seq);
            }
          }
        },
        addCategory(){
          this.boardData.unshift({
            "bc_name": '', // 카테고리명
            "bc_seq": 0, //노출순서
          })
        },
        save(key, seq, name) {
            this.writeCategory(key, seq, name);
        },
        deleteConfirm(row, idx) {
          let key = row.hasOwnProperty('bc_idx') && !util.isEmpty(row.bc_idx) ? row.bc_idx : ''
          if(util.isEmpty(key)){
            this.boardData.splice(idx, 1);
          }else{
            console.log(key)
            this.deleteCategory(key);
          }
        },
    },
    watch: {

    },
}
</script>

<style scoped>

</style>
